/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Importing_ToastInputs */

const en_subtitle_import_importing_toast = /** @type {(inputs: Subtitle_Import_Importing_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing subtitle events...`)
};

const fr_subtitle_import_importing_toast = /** @type {(inputs: Subtitle_Import_Importing_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation des evenements de sous-titres...`)
};

const de_subtitle_import_importing_toast = /** @type {(inputs: Subtitle_Import_Importing_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelereignisse werden importiert...`)
};

const it_subtitle_import_importing_toast = /** @type {(inputs: Subtitle_Import_Importing_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione degli eventi dei sottotitoli...`)
};

const ru_subtitle_import_importing_toast = /** @type {(inputs: Subtitle_Import_Importing_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт событий субтитров...`)
};

const es_subtitle_import_importing_toast = /** @type {(inputs: Subtitle_Import_Importing_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando eventos de subtítulos...`)
};

const zh_cn2_subtitle_import_importing_toast = /** @type {(inputs: Subtitle_Import_Importing_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在导入字幕事件...`)
};

const ja_subtitle_import_importing_toast = /** @type {(inputs: Subtitle_Import_Importing_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕イベントをインポートしています...`)
};

const hi_subtitle_import_importing_toast = /** @type {(inputs: Subtitle_Import_Importing_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक इवेंट आयात किए जा रहे हैं...`)
};

const pt_pt2_subtitle_import_importing_toast = /** @type {(inputs: Subtitle_Import_Importing_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando eventos de legenda...`)
};

/**
* | output |
* | --- |
* | "Importing subtitle events..." |
*
* @param {Subtitle_Import_Importing_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_importing_toast = /** @type {((inputs?: Subtitle_Import_Importing_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Importing_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_importing_toast(inputs)
	if (locale === "de") return de_subtitle_import_importing_toast(inputs)
	if (locale === "it") return it_subtitle_import_importing_toast(inputs)
	if (locale === "ru") return ru_subtitle_import_importing_toast(inputs)
	if (locale === "es") return es_subtitle_import_importing_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_importing_toast(inputs)
	if (locale === "ja") return ja_subtitle_import_importing_toast(inputs)
	if (locale === "hi") return hi_subtitle_import_importing_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_importing_toast(inputs)
	return en_subtitle_import_importing_toast(inputs)
});